<script lang="ts" setup>
import { formatPrice } from '@/utils/price.util.ts'
import { translate } from '@/i18n/i18n.ts'
import type { PriceDisplayProps } from '@/components/atom/price-display/PriceDisplay.vue'
import { usePriceDisplayState } from '@/composables/state/price-display-state.composable.ts'

const props = defineProps<PriceDisplayProps>()

const state = usePriceDisplayState(props)
const { classes, showPrefix, showPriceNumber } = state
</script>

<template>
  <div :class="classes">
    <div class="price-display__simple-wrapper">
      <div class="price-display__text-wrapper">
        <div v-if="showPrefix" class="price-display__price">
          {{ translate('product.payment_prefix_from') }}
        </div>
        <div class="price-display__price">
          <span v-if="showPriceNumber">{{ formatPrice(props.price!) }}</span>
          <span v-else><span class="price-display__invalid"></span> €</span>
        </div>
      </div>
      <div class="price-display__label">{{ translate('product.payment_interval_annually') }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'a-price-display';
</style>
